export default __webpack_public_path__ + "static/media/image.5701e72a.png";